import { User } from '../../../user/models/user.type';
import { UserService } from './../../../user/services/user.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ProductService } from '../../service/product.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { DividerModule } from 'primeng/divider';
import { CarouselModule } from 'primeng/carousel';
import { AccordionModule } from 'primeng/accordion';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { TippyDirective } from '@ngneat/helipopper';
import { FileUploadModule } from 'primeng/fileupload';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { ProductAttributesComponent } from '../product-attributes/product-attributes.component';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { Channel } from '../../model/channel.type';
import { FormsModule } from '@angular/forms';
import { ChannelService } from '../../../import/service/channel.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HistoryDialogComponent } from '../../../shop/history-dialog/history-dialog.component';
import { Util } from '../../../../utils/util';
import { CategoryService } from '../../../import/service/category.service';
import { Message } from 'primeng/message';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-operator-product',
  standalone: true,
  imports: [
    TranslateModule,
    CardModule,
    SelectModule,
    ButtonModule,
    TagModule,
    TimelineModule,
    DividerModule,
    CarouselModule,
    AccordionModule,
    GalleriaModule,
    ImageModule,
    TippyDirective,
    FileUploadModule,
    RouterLink,
    ProductAttributesComponent,
    TooltipModule,
    CommonModule,
    FormsModule,
    Message
  ],
  templateUrl: './operator-product.component.html',
  styleUrl: './operator-product.component.scss',
  providers: [DialogService],
})
export class OperatorProductComponent implements OnInit {
  product: any;
  displayGalleria: boolean = false;
  activeIndex;
  selectedProduct: any = null;
  user: User;
  sellerProducts;
  productId: string;
  channels;
  userChannels = [];
  selectedChannel: Channel = this.channelService.getSelectedChannel();
  defaultLocale;
  productStatus = [];
  selectedProductHighlight;
  locales;
  ref: DynamicDialogRef | undefined;
  isSellerProduct = false;
  categories;
  messages = [];
  expandedStates: boolean[] = [];
  @ViewChild(ProductAttributesComponent)
  productAttributesComponent: ProductAttributesComponent;
  constructor(
    private readonly productService: ProductService,
    private readonly userService: UserService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly channelService: ChannelService,
    private readonly dialogService: DialogService,
    private readonly categoryService: CategoryService,
    public translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUser();
    this.userChannels = this.user.relatedChannels;
    this.selectedChannel = this.channelService.getSelectedChannel();
    this.defaultLocale = this.channelService.getSelectedLocale();
    this.initCategories();
    this.activatedRoute.params.subscribe((params) => {
      this.productId = params['id'];
      this.initLocales();
    });
  }

  initProduct() {
    this.product = null;
    this.selectedProduct = null;
    this.messages = [];
    this.productService
      .getOperatorMasterProduct(
        this.productId,
        this.user?.email,
        this.selectedChannel.channelCode,
        this.locales,
        this.defaultLocale,
      )
      .subscribe({
        next: (res) => {
          this.product = res;
          this.selectedProductHighlight = this.product.productId;
          this.selectedProduct = structuredClone(this.product);
          this.productStatus = structuredClone(this.product.productStatus);
          let i = 1;
          this.productStatus = this.productStatus?.map((status) => {
            status.step = i + '/3';
            i++;
            status.statusCode = 'detailProduct.' + status.statusCode;
            status.statusDescription = status.statusCode + 'Description';
            return status;
          });
          if (this.product.editorialCharter?.rejection || '') {
            this.messages.push({
              severity: this.product.editorialCharter.status,
              summary: this.product.editorialCharter.rejection,
              detail: this.product.editorialCharter.description,
            });
          }
          if (this.product.publicationStatusErrors?.length > 0) {
            const messages = this.product.publicationStatusErrors
              .map((error) => Util.buildMessage('-', error, ['level', 'attributeCode', 'message']) )

            this.messages.push({
              severity: this.product.publicationStatusErrors[0].status.toString().trim() === "SYNCHRONIZED" ? 'Warning' :'Error',
              summary: this.product.publicationStatusErrors[0].status,
              detail: messages,
            });
          }
          this.sellerProducts = this.product.sellerProducts;
        },
      });
  }

  initCategories() {
    Util.initCategories(this.categoryService, this.channelService)().then(
      (categories) => {
        this.categories = categories;
        for (let node of this.categories) {
          Util.handleSlectableNodes(node);
        }
      },
    );
  }


  changeSelectedChannel(event) {
    this.selectedChannel = event;
    this.channelService.setSelectedChannel(this.selectedChannel);
    this.initLocales(this.selectedChannel);
  }

  handleProductClick(product, isSellerProduct = false) {
    this.selectedProductHighlight = product.productId;
    this.locales = this.channelService.getSavedLocales();
    this.isSellerProduct = isSellerProduct;
    if (isSellerProduct) {
      this.productService
        .getProduct(
          product?.productId.trim(),
          this.user.email,
          this.selectedChannel.channelCode,
          this.locales,
          this.defaultLocale,
        )
        .subscribe({
          next: (res) => {
            this.selectedProduct = res;
            this.productAttributesComponent.fetchAndInitializeProductAttributes(
              this.selectedProduct,
            );
          },
        });
    } else {
      this.initProduct();
    }
  }

  openHistoryDialog() {
    this.ref = this.dialogService.open(HistoryDialogComponent, {
      header: this.translate.instant('shop.actionsHistory'),
      closable: true, 
      data: { productId: this.productId, type: 'product' },
      width: '65vw',
      height: '75vh',
      modal: true,
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
    });
  }

  getSeverity(status: string) {
    return Util.getSeverity(status);
  }

  initLocales(channel = null) {
    if (channel == null) {
      channel = this.channelService.getSelectedChannel();
      this.defaultLocale = this.channelService.getSelectedLocale();
    }
    this.channelService.getLocales(channel).subscribe({
      next: (res: any) => {
        this.locales = res.locales;
        this.defaultLocale = this.channelService.getSelectedLocale();
        this.initProduct();
      },
    });
  }

  refreshProduct($event) {
    this.initProduct();
  }

  updateLocale(event) {
    if (event != this.defaultLocale) {
      this.defaultLocale = event;
      this.channelService.setSelectedLocale(event);
      this.initProduct();
    }
  }
  getMessageSeverity(message: string) {
    return Util.getMessageSeverity(message);
  }
  isPublicationStatusErrors(product) {
    return product?.publicationStatusErrors.length > 0 ? product?.publicationStatusErrors[0].message != "" : false;
  }
  getSeverityForPublicationStatus(status, product) {
    return Util.getSeverityForPublicationStatus(status, this.isPublicationStatusErrors(product));
  }

  getDetailArray(detail: any): string[] {
    return Util.getDetailArray(detail);
  }

  isArray(obj) {
    return Util.isArray(obj);
  }

   // Nouvelle méthode pour toggle l'expansion d'un message dans la liste
  toggleExpand(index: number): void {
    // Initialise le tableau si nécessaire
    if (!this.expandedStates[index]) {
      this.expandedStates[index] = false;
    }
    
    // Toggle l'état
    this.expandedStates[index] = !this.expandedStates[index];
  }
  onDownload() {
    let url = environment.docsBucketUrl;
    if(this.translate.currentLang === 'fr') {
      url = url + "Product/FR/Guide%20des%20messages%20d%E2%80%99erreur%20du%20Portail%20Catalogue.pdf";
    } else {
      url = url + "Product/EN/Catalog%20Portal%20Error%20Message%20Guide.pdf"
    }
    Util.downloadDoc(url)
  }

  getTutoLink() {
    if(this.translate.currentLang === 'fr') {
      return environment.docsBucketUrl +'Fiche%20produit/FR/Catalog%20-%20FR%20-%20Vendeur%20-%20Consulter%20une%20fiche%20produit%2C%20comprendre%20les%20statuts%20de%20la%20fiche%2C%20des%20attributs%20et%20les%20modifications%20%C3%A0%20apporter.pdf'
    }else {
      return environment.docsBucketUrl + "Fiche%20produit/EN/Catalog%20-%20EN%20-%20Seller%20-%20Consult%20a%20product%20sheet%2C%20understand%20the%20sheet'%20status%2C%20attributes%20and%20the%20modifications%20to%20make.pdf"
    }
    
  }
}
